import querystring from 'querystring';
import _omit from 'lodash/omit';

import { CTA_SHOW_MAP_VIEW } from './constants';

export const getLocationIdsFromProvidersData = (providersData = {}) => {
  const facet = (providersData.facets || []).find(
    (facet) => facet.field === 'locations.primary_marketable_location_id'
  );
  return facet ? facet.terms.map((termData) => termData.value) : [];
};

/**
 * Callback function when MapSearchLinkBlock is clicked
 * @param {object} e the event fired
 * @param {function} log analytics logging
 * @param {string} mapSearchUrl the URL to the Map Search page
 * @param {object} history react-router history
 * @returns undefined
 */
export const mapSearchCallbackFunction = (e, log, mapSearchUrl, history) => {
  e.preventDefault();
  log(CTA_SHOW_MAP_VIEW);
  history.push(mapSearchUrl);
};

export const getBackToListView = (locationsQuery, omitParams) => {
  const queryParams = querystring.parse((locationsQuery || '').substring(1));
  const newQueryParams = _omit(queryParams, omitParams);
  return `/search?${querystring.stringify(newQueryParams)}`;
};

/**
 * Formats a map location to be passed to the @kyruus/gmap component
 * @param {object} mloc
 * @returns {object}
 */
export const formatLocationForGoogleMap = (mloc) => ({
  name: `View providers at ${mloc.name}`, // hacky way of ensuring @kyruus/gmap renders this as aria-label
  id: mloc.id,
  coordinates: (mloc.address || {}).coordinates
});

/**
 * Generates a document querySelector for a location's Google Maps pin
 * @param {object} selectedLocation { name: string }
 * @returns string
 */
export const generateLocationPinQuerySelector = (selectedLocation) => {
  const formatted = formatLocationForGoogleMap(selectedLocation);

  return `div[role="button"][aria-label="${formatted.name}"][title="${formatted.name}"]`;
};

/**
 * Gets a gmap LatLng objects from an mloc.
 * https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLngLiteral
 * @param {} mloc
 * @returns
 */
export function gMapLatLngForMloc(mloc) {
  return {
    lat: mloc.address.coordinates.lat,
    lng: mloc.address.coordinates.lon
  };
}

export function centerMarkerRelativeToSwipeableDrawer(
  map,
  marker,
  referenceElement
) {
  if (!map || !marker) return;

  if (!referenceElement) return;

  const refRect = referenceElement.getBoundingClientRect();
  const mapContainer = map.current.getContainer();
  const mapContainerRect = mapContainer.getBoundingClientRect();

  const targetXViewport = refRect.left + refRect.width / 2;

  const targetYViewport = refRect.top;

  const targetXMap = targetXViewport - mapContainerRect.left;
  const targetYMap = targetYViewport - mapContainerRect.top;

  const markerLngLat = marker.getLngLat();
  const currentScreenPoint = map.current.project(markerLngLat);
  const markerElement = marker.getElement();
  const markerElementHeight = markerElement.getBoundingClientRect().height;

  const deltaX = targetXMap - currentScreenPoint.x;
  const deltaY = targetYMap - currentScreenPoint.y - markerElementHeight / 2;

  const currentCenterScreenPoint = map.current.project(map.current.getCenter());

  const newCenterScreenPoint = {
    x: currentCenterScreenPoint.x - deltaX,
    y: currentCenterScreenPoint.y - deltaY
  };

  const newCenterLngLat = map.current.unproject(newCenterScreenPoint);

  map.current.flyTo({
    center: newCenterLngLat,
    duration: 1200, // Smooth transition
    essential: true
  });
}
